import React from 'react';
import PropTypes from 'prop-types';
import {OutsourceListMode} from "../../my-outsources/outsource/list/OutsourceListMode";
import HeaderSearchRefreshFilterOptions from '../../shared/components/HeaderSearchRefreshFilterOptions';
import Card from '../../shared/components/Card';
import CardHeader from '../../shared/components/card-header/CardHeader';
import CardBody from '../../shared/components/CardBody';
import { I18nUtils } from '../../../i18n/I18nUtils';
import OutsourceChartLegend from './OutsourceChartLegend';
import Row from '../../shared/components/Row';
import Paginator from '../../shared/components/Paginator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as outsourceActions from '../actions/outsourceActions';
import * as documentStateActions from '../../documents/actions/documentStatesActions';
import StateManager from '../../shared/utils/StateManager';
import OutsourceListGrid from '../../my-outsources/outsource/list/OutsourceListGrid';
import { OutsourceListTable } from '../../my-outsources/outsource/list/OutsourceListTable';
import { CompaniesExportRequest } from '../../my-outsources/outsource/list/companies-export/CompaniesExportRequest';
import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import cookie from 'react-cookies';
import { AUTH_TOKEN } from '../../shared/utils/CookiesManager';
import Alert from 'react-s-alert';

const OptionsMore = {
    NONE: '',
    DOWNLOAD: 'DOWNLOAD',
};

class OutsourcesCard extends React.Component {

    STATE_MANAGER_KEY = 'OUTSOURCES_CARD';

    constructor(props) {
        super(props);

        this.onRefresh = this.onRefresh.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onPage = this.onPage.bind(this);
        this.onCollapsed = this.onCollapsed.bind(this);

        this.state = {
            ...StateManager.getState(this.STATE_MANAGER_KEY, { ...StateManager.DEFAULT_STATE, mode: OutsourceListMode.GRID }),
            collapsed: this.props.initCollapsed ? true : false,
            moreOptionSelected: OptionsMore.NONE,
            loading: false,
        };
    }

    componentWillMount() {
        this.props.documentStateActions.getDocumentStates();
        if ( !this.state.collapsed ) {
            this.getOutsources();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if ( prevState.search !== this.state.search
            || prevState.page !== this.state.page
            || prevState.filter !== this.state.filter
            || prevState.collapsed !== this.state.collapsed
        ) {
            if ( !this.state.collapsed ) {
                this.getOutsources();
            }
        }
        StateManager.saveState(this.STATE_MANAGER_KEY, this.state);
    }

    getOutsources() {
        this.props.outsourceActions.getCompanies(this.state.page, this.state.search, this.state.filter !== -1 ? this.state.filter === 0 : null);
    }

    onRefresh() {
        this.getOutsources();
    }

    onSearch(search) {
        this.setState({ search: search, page: 1 });
    }

    onPage(page) {
        this.setState({ page });
    }

    onCollapsed(collapsed) {
        this.setState({ collapsed: collapsed });
        if ( this.props.collapsed ) {
            this.props.collapsed(collapsed);
        }
    }

    getFilterOptions() {
        const filterOptions = [];
        filterOptions.push({
            id: -1,
            title: I18nUtils.tr('TR_TODAS'),
            active: -1 === this.state.filter,
            onClick: () => {
                this.setState({ filter: -1, page: 1 });
            },
        });
        filterOptions.push({
            id: 0,
            title: I18nUtils.tr('TR_ACTIVAS'),
            active: 0 === this.state.filter,
            onClick: () => {
                this.setState({ filter: 0, page: 1 });
            },
        });
        filterOptions.push({
            id: 1,
            title: I18nUtils.tr('TR_INACTIVAS'),
            active: 1 === this.state.filter,
            onClick: () => {
                this.setState({ filter: 1, page: 1 });
            },
        });
        return filterOptions;
    }

    moreOptions() {
        const {
            moreOptionSelected,
        } = this.state;

        return [
            {
                id: 'download_csv',
                title: I18nUtils.tr('TR_EXPORTAR_CSV'),
                active: moreOptionSelected === OptionsMore.DOWNLOAD,
                onClick: this.handleFetchDownloadCsv,
            },
        ];
    }

    renderHeaderOptions() {
        return (
            <HeaderSearchRefreshFilterOptions
                onRefresh={this.onRefresh}
                onSearch={this.onSearch}
                searchText={this.state.search}
                filterOptions={this.getFilterOptions()}
                collapsed={this.state.collapsed}
                onCollapsed={this.props.initCollapsed !== null && this.onCollapsed}
                moreOptions={this.moreOptions()}
            />
        );
    }

    handleFetchDownloadCsv = () => {
        const {
            filter,
            page,
            search,
        } = this.state;

        const requestBody = new CompaniesExportRequest();
        requestBody.setPage(page);
        requestBody.setTerm(search);
        requestBody.setState(filter);

        const genericRequest = new GenericRequest(METHOD_POST, ApiEndpoints.OUTSOURCES_EXPORT);
        let headers = genericRequest.headers;
        const authToken = cookie.load(AUTH_TOKEN);
        if (authToken) {
            headers.Authorization = 'Bearer ' + cookie.load(AUTH_TOKEN);
        }
        const requestInit = {
            method: genericRequest.method,
            headers: headers,
            mode: 'cors',
            body: JSON.stringify(requestBody.body()),
        };
        this.setState({ loading: true });
        fetch(genericRequest.url, requestInit)
            .then(response => {
                this.setState({ loading: false });
                response.blob().then(function (myBlob) {
                    const url = URL.createObjectURL(myBlob);
                    window.open(url, '_blank');
                });
            })
            .catch(error => {
                this.setState({loading: false});
                Alert.error(error || I18nUtils.tr('TR_ERROR_AL_EXPORTAR_EL_CSV'));
            });
    };

    render() {
        const {
            outsourcesLoading,
            documentStates,
            outsources,
            outsourcesError,
            outsourcesPagination,
            title,
        } = this.props;

        return (
            <Row clearfix>
                <Card loading={outsourcesLoading}>
                    <CardHeader
                        title={title.toUpperCase()}
                        subtitle={I18nUtils.tr('TR_RECIEN_VISTAS')}
                        rightOptions={this.renderHeaderOptions()}
                    />
                    {
                        !this.state.collapsed ? (
                            <CardBody styles={{ overflowX: 'auto' }}>
                                <div>
                                    <div className="row subcontrata-clave">
                                        <div className="col-xs-8">
                                            <OutsourceChartLegend data={documentStates} />
                                        </div>
                                        <div className="col-xs-4">
                                            <div className="grid-list pull-right">
                                                <a id="list" onClick={() => this.setState({ mode: OutsourceListMode.LIST })}>
                                                    <i className="material-icons">list</i>
                                                </a>
                                                <a id="grid" onClick={() => this.setState({ mode: OutsourceListMode.GRID })}>
                                                    <i className="material-icons">view_module</i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <hr></hr>
                                    {
                                        this.state.mode === OutsourceListMode.GRID ?
                                            <OutsourceListGrid outsources={outsources}/> :
                                            <OutsourceListTable
                                                data={outsources}
                                                loading={outsourcesLoading}
                                                error={outsourcesError}
                                            />
                                    }

                                    <hr></hr>
                                    <Paginator onPage={this.onPage} data={outsourcesPagination} />
                                </div>
                            </CardBody>
                        ) : null
                    }
                </Card>
            </Row>
        );
    }
}

const mapStateToProps = state => {
    let errorMessage = state.outsources.outsourcesError;
    if ( !errorMessage && state.outsources.outsources.length === 0 && !state.outsources.outsourcesLoading ) {
        errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
    }
    return ( {
        outsources: state.outsources.outsources,
        outsourcesPagination: state.outsources.outsourcesPagination,
        outsourcesLoading: state.outsources.outsourcesLoading,
        outsourcesError: errorMessage,

        documentStates: state.documentStates.documentStates,
    } );
};

const mapDispatchToProps = dispatch => ( {
    outsourceActions: bindActionCreators(outsourceActions, dispatch),
    documentStateActions: bindActionCreators(documentStateActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(OutsourcesCard);

OutsourcesCard.propTypes = {
    limitPage: PropTypes.number,
    title: PropTypes.string,
    initCollapsed: PropTypes.bool,
    collapsed: PropTypes.func,
};

OutsourcesCard.defaultProps = {
    limitPage: 6,
    title: I18nUtils.tr('TR_SUBCONTRATAS').toUpperCase(),
    initCollapsed: null,
    collapsed: (collapsed) => {},
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/OursourcesCard.jsx